import { Link } from "react-router-dom";
import "./CTAHero.css";
type CTAHeroProps = {
  title?: string;
  link?: string;
  linkText?: string;
  action?: () => void;
  actionText?: string;
  textColor: string;
  background: string;
  xl: boolean;
};
const CTAHero = ({
  title,
  link,
  linkText,
  textColor,
  background,
  action,
  actionText,
  xl,
}: CTAHeroProps) => {
  const size = xl
    ? `cta-hero-container cta-hero-container-xl ${background}-cta-hero-container`
    : `cta-hero-container ${background}-cta-hero-container`;
  return (
    <div className={size}>
      {link && (
        <Link to={link} className={`cta-btn ${textColor}-cta-btn`}>
          {linkText}
        </Link>
      )}
      {action && (
        <button onClick={action} className={`cta-btn ${textColor}-cta-btn`}>
          {actionText}
        </button>
      )}
      {title && (
        <div
          className={`cta-hero-title-wrapper ${textColor}-cta-hero-title-wrapper`}
        >
          <h2 className={`cta-hero-title ${textColor}-cta-hero-title`}>
            {title}
          </h2>
        </div>
      )}
    </div>
  );
};

export default CTAHero;
